(function (doc, win) {
	var docEl = doc.documentElement,
		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {	
            setTimeout(() => { 
                const _bodyHeight = document.body.clientHeight
                const _newNavbar = docEl.getElementsByClassName("newNavbar")[0]
                if(_newNavbar){
                  const _newNavbarHeight = _newNavbar.clientHeight
                  const _planMapDoc = docEl.getElementsByClassName("Plan-Map")[0]
                  if (_planMapDoc) {
                    _planMapDoc.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30 -30 - 20) + 'px'    
                  }

                  const _planDay = docEl.getElementsByClassName("Plan-Day")[0]
                  if(_planDay){
                    _planDay.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 20) + 'px'  
                  }
                
                  
                  const _leftDay = docEl.getElementsByClassName("Left-Day")[0]
                  if(_leftDay){
                    _leftDay.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30) + 'px' 
                  }
                  const _planMapCpm = document.getElementsByClassName("CPM")[0]
                  if (_planMapCpm) {
                    _planMapCpm.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30 -20) + 'px'    
                  }

                  const _planBudget = docEl.getElementsByClassName("Plan-Budget")[0]
                  if(_planBudget){
                    _planBudget.style.maxHeight = (_bodyHeight - _newNavbarHeight - _navbarHeight - 20) + 'px'   
                  }
                }
                const _navbar = docEl.getElementsByClassName("navbar")[0]
                if(_navbar){
                  const _navbarHeight = _navbar.clientHeight
                }
                
    
                
                 

                
                // console.log('hhh',_bodyHeight,_navBarHeight)       
            },500)
		};
	if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    win.addEventListener('unload', recalc, false);
	doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window) 